/** Wien Mitte Train Station — CAT terminus / last-mile walking origin. */
export const WIEN_MITTE_STATION = {
  latitude: 48.2063674296469,
  longitude: 16.384743642330236
} as const;
